const UPLOADS_CDN = process.env.REACT_APP_UPLOADS;
const RESIZE_CDN = process.env.REACT_APP_RESIZABLE;
const CDN = process.env.REACT_APP_CDN;

const LogoAvatar = ({slug, logo, resize = false, isAvatarActive, avatarClass, header = false}) => {
    const logoUrl = header ? CDN : resize ? RESIZE_CDN : UPLOADS_CDN;
    return (
        logo ? (
            <img
                className={`sl-avatar ${avatarClass} ${isAvatarActive ? 'sl-avatar-active' : ''}`}
                src={`${logoUrl}/${logo}`}
                alt={slug}
            />
        ) : (
            <span
                className={`sl-avatar ${avatarClass} ${isAvatarActive ? 'sl-avatar-active' : ''}`}
                data-letters={`${slug.charAt(0)}`}
            />
        )
    );
};

export default LogoAvatar;
